import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Oshokujidokoro.css';

const storyTitles = [
    '猪排饭的真剑胜负',
    '那家江户前寿司店没有一把椅子'
];

const Oshokujidokoro = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const navigate = useNavigate();

    return (
        <div className="oshokujidokoro-container">
            {/* Decorative Frame */}
            <div className="oshokujidokoro-frame">
                <div className="oshokujidokoro-frame-border oshokujidokoro-frame-tl"></div>
                <div className="oshokujidokoro-frame-border oshokujidokoro-frame-tr"></div>
                <div className="oshokujidokoro-frame-border oshokujidokoro-frame-b"></div>
                <div className="oshokujidokoro-frame-border oshokujidokoro-frame-l"></div>
            </div>

            <div className="oshokujidokoro-contents">
                {/* Logo */}
                <img 
                    src="/logo.png" 
                    alt="Logo" 
                    className="oshokujidokoro-logo" 
                    onClick={() => navigate('/')}
                />

                {/* Main Container */}
                <div className="oshokujidokoro-main-container">
                    <div className="oshokujidokoro-main-title">
                        <h2>食事处</h2>
                    </div>

                    {/* Responsive Layout */}
                    <div className="oshokujidokoro-layout">
                        {/* Article Titles */}
                        <div className="oshokujidokoro-titles">
                            {storyTitles.map((title, idx) => (
                                <div
                                    key={idx}
                                    onClick={() => setActiveIndex(idx)}
                                    className={`oshokujidokoro-title-item ${activeIndex === idx ? 'active' : ''}`}
                                >
                                    {title}
                                </div>
                            ))}
                        </div>

                        {/* Content Area */}
                        <div className="oshokujidokoro-content">
                            {activeIndex !== null ? (
                                <div>
                                    <div className="oshokujidokoro-content-title">
                                        {storyTitles[activeIndex]}
                                    </div>
                                    <div className="oshokujidokoro-content-text">
                                        {activeIndex === 0 && (
                                            <div>
                                                <br/>
                                                <p>考试之前也好，比赛之前也好，我总是会去吃一次猪排饭。</p>
                                                <p>其实这只是一个日本人的文字游戏：猪排（カツ）与胜利（勝つ）是同音，意即吃了猪排就可以赢。同样的，日本人还会吃kitkat，因为读音与一定会赢（きっと勝つ）相似。大概类似于中国要8不要4那种的讨个好彩头。更多地来说，猪排饭确实很好吃；偏好动物蛋白、油脂与碳水化合物，这是我们的祖先随着进化而被给予的本能。伴着咽下一大堆卡路里的罪恶感，我想你也能添那么几次米饭和味增汤。</p>
                                                <p>留学生们一定不会陌生街边的各种美式日料。我双手赞成在东京你可以随便挑一些路边的餐馆碰碰运气，但是在多伦多你必须承认——加拿大，甚至于北美，确实无愧于美食荒漠之名。</p>
                                                <p>如果你也厌倦了带着冰渣的刺身以及万能的美乃滋，你不妨留意一下餐馆的营业时间；大多数日本餐馆都会在下午留出几个小时用来收拾以及准备晚餐。我想，如果食材不是随便一切而是认真准备，桌子不是随便一擦而是认真收拾，我更愿意去尝试这样的餐馆。毕竟，照烧鸡排可不是生鸡肉煎完了淋上买来的酱那么简单。对于我来说，我更愿意相信Mr.Tonkatsu是一个日本或者韩国人开的餐馆——从他们把authentic拼错的事情上来看。</p>
                                                <img src="z1.jpg" width="100%" alt="猪排饭图片1" />
                                                <p>但是实际上，猪排应该也是有流派的，有的猪排会用粗一点的面包糠，有的会用细的。不过据我观察，韩国人的猪排大多都用细的面包糠放少油煎炸，而日本人则反之。同样地，韩国人自然会配泡菜，日本人则会给你卷心菜丝。</p>
                                                <p>猪排拿出来反复敲打到猪排上布满痕迹，然后放进蛋液里，接着将猪排埋进自家制的面包糠中。炸猪排的时间在感觉上是漫长的，油炸的声音似乎能勾起人的食欲；而等待猪排熟透的时间里你只能坐在椅子上把你的迫不及待全都发泄在那碗小小的芝麻上。</p>
                                                <img src="z2.jpg" width="100%" alt="猪排饭图片2" />
                                                <p>以我个人角度来说，我喜欢不那么肥，而且有嚼劲的猪排，所以我总是会点里脊。当然，如果你不介意再来点热量的话，他们还提供爆浆猪排；除此之外，还有鱼和鸡排之类的。配上荞麦面据说是韩国人喜欢的一种吃法，毕竟，除了米饭之外所有东西都是配菜呀。对于一个十刀出头的set，Mr.Tonkatsu的分量也算得上是良心，比起北京那个连锁的胜博殿，Mr.Tonkatsu在分量上也更胜一筹。不过，如果你想点一下他们的日本茶的话，你会发现他们给了你一些水和一个茶包。</p>
                                                <p>相对于开在downtown core的那些日本外卖店来说，Mr.Tonkatsu显得人少了很多。不过却是一个可以来解决中午饭或者晚饭的好地方，他们甚至可以打包味增汤。诚然，无论你是否有时间吃猪排饭，我都希望你可以抱着胜利的心情去对待你的每一次考试/比赛，就像你对待那碗猪排饭一样。</p>
                                                <p><br/>官网：http://www.mrtonkatsu.com</p>
                                                <p><br/>*图片来自于官网</p>
                                            </div>
                                        )}
                                        {activeIndex === 1 && (
                                            <div>
                                                <br/>
                                                <p>所谓たち（tachi）的汉字其实是"立"。没错，这家寿司店没有一把椅子，从顾客到师傅全都是站着。这也是为什么这家餐厅能够开在欧美大排档的某个角落——用餐地点恐怕还没我的卧室面积大。这对于不熟悉江户前寿司的人想必是不能接受的，在逼仄的空间里站着用二十多分钟解决掉十几贯寿司，这完全就是Fine-dining的正反面嘛！</p>
                                                <p>所谓江户前寿司，其实大多是指用东京湾（东京古称江户）所捕捞的海鲜所做的寿司。在我看来，江户前料理大多讲究一个"本味"。无论是天妇罗，还是寿司，都在追求用某种方法呈现食物最好的状态。这也是为什么寿司和天妇罗应当尽快吃掉的原因，毕竟放久了就不是最好状态了。</p>
                                                <p>对于江户前寿司来说，我认为料理和用餐体验需要分成两部分。</p>
                                                <p>单从料理来讲，tachi无疑是出色的。只提供omakase，根据当天的鱼获不同提供不同的寿司，也并不是全都是他们官网上列出的那几类。众所周知的，作为一个内陆城市，多伦多想拿到新鲜的鱼应该没有上海或者东京那么容易。而且在北美生食并不是大多数鱼的主要食用方式，提起金枪鱼美国人可能会想起做成罐头而不是握寿司。对于tachi的金枪鱼，大腹完全可以呈现出高脂肪率带来的入口即化的口感。</p>
                                                <img src="t1.jpg" width="100%" alt="寿司图片1" />
                                                <p>前两贯寿司分别是贝柱和金目鲷，金目鲷并没有写在官网的菜单上，也许是师傅看见今天有新鲜的金目鲷才用做材料的。这也是江户前寿司的本意——用新鲜的鱼做料理。</p>
                                                <img src="t2.jpg" width="100%" alt="寿司图片2" />
                                                <p>后来才得知，金目鲷是从一个我会偶尔光顾的日本鱼店进货的（taro's fish）。从波士顿运来的海胆似乎不如日本的出色，不过这也受制于地理的原因。</p>
                                                <img src="t3.jpg" width="100%" alt="寿司图片3" />
                                                <p>虾类是做熟然后去尾，这可能是为方便大家——他们的寿司都是刷好酱油（或者其他的酱料），你只需要拿起来放到嘴里就好。</p>
                                                <p>提起寿司，多数人想起的可能是加州卷，但是并不是，加州卷本来是一位姓东条的加拿大人发明的（其实夏威夷披萨也是加拿大人发明的）。原因是北美的人并不喜欢吃生鱼和海苔，所以米饭就被卷在了外面，鱼生被替换成了蟹肉，还加入了黄瓜和牛油果。因此这种料理便在加利福尼亚流行开来，也是各位所熟知的美式料理的一种。正宗的手卷的海苔应该卷在外面——也是你在tachi能吃到的一种寿司。</p>
                                                <img src="t4.jpg" width="100%" alt="寿司图片4" />
                                                <p>说到用餐体验，恐怕tachi并不是那种提供完美用餐体验的餐厅。没有一把椅子，寿司师傅忙于捏寿司，二十分钟左右结束一餐并且极度讨厌预约迟到。唯一类似于菜单的印刷物上面写着七种可以提供的饮品。总之，从各种意义上来说，这家店完全是小野二郎的画风，也就是并不是那种轻松愉快聊聊天吃吃饭的餐厅。就算小野二郎当选了米芝莲三星主厨（米芝莲只评价料理水平），我认为也没必要过分吹捧如此的模式。如上所说，各位如果想把妹的时候最好还是不要预定这家餐厅，毕竟把妹的时候你不是很在意吃的是什么，而且你不想让妹子和你一起站着。</p>
                                                <p>如果你并没有体验过江户前寿司的话，我想tachi算是一个不错的寿司入门店，对于45刀十几贯寿司的价格也还算公平（因为就在G的楼下，而且金融区的各位对吃饭的需求的价格弹性并不是很大）。不过幸好多伦多还算是个文化融合的城市，如果你不喜欢寿司的话可以去尝试别的地方的料理。但是我想，无论什么民族的什么料理，大概都有认同它并为之付出的料理人吧。</p>
                                                <p><br/>官网：http://www.tachistandup.com</p>
                                                <p><br/>Taro's fish：https://tarosfish.wordpress.com</p>
                                                <p><br/>*部分图片来自官网</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className="oshokujidokoro-placeholder">
                                    🍽️
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Oshokujidokoro; 